module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figD01_sector-pitch-and-pitch-span-deviation.7a0fe1be.png";